// extracted by mini-css-extract-plugin
export var active = "previewWrapper-module--active--2gYs9 previewWrapper-module--common--285FT";
export var common = "previewWrapper-module--common--285FT";
export var img = "previewWrapper-module--img--1LU-e";
export var inactive = "previewWrapper-module--inactive--nqMcs previewWrapper-module--common--285FT";
export var previewImage = "previewWrapper-module--preview-image--LT3h+";